import React from 'react';
import PropTypes from 'prop-types';
import { FULFILLMENT_METHODS } from '../../../constants';

const ShippingThreshold = ({ type, hasFreeShipping, freeDeliveryThreshold, totalCharge }) => {
  if (type === 'sth') {
    if (!hasFreeShipping && freeDeliveryThreshold) {
      return (
        <div>
          <span className="u__bold u__text--success">
            Free with ${parseInt(freeDeliveryThreshold, 10)} order
          </span>
        </div>
      );
    }
    if (hasFreeShipping) {
      return (<span className="u__bold u__text--success">FREE</span>);
    }
    return null;
  }

  if (type === 'express delivery') {
    if (totalCharge === 0 || !totalCharge) {
      return <span className="u__bold u__text--success">FREE</span>;
    }
  }

  if (type === FULFILLMENT_METHODS.APPLIANCE) {
    if (hasFreeShipping) {
      return <span className="u__bold u__text--success">FREE</span>;
    }
  }

  return null;
};

ShippingThreshold.propTypes = {
  type: PropTypes.string,
  hasFreeShipping: PropTypes.bool,
  freeDeliveryThreshold: PropTypes.number,
  totalCharge: PropTypes.number
};

ShippingThreshold.defaultProps = {
  type: null,
  hasFreeShipping: false,
  freeDeliveryThreshold: null,
  totalCharge: null
};

export { ShippingThreshold };
